<template>
  <div class="container mt-5">
    <div class="row justify-content-center">
      <div class="col-md-6 col-lg-4">
        <div class="card">
          <div class="card-header bg-secondary text-white">
            <h3 class="card-title m-0">Login</h3>
          </div>
          <div class="card-body">
            <form @submit.prevent="logged">
              <div class="mb-3" :class="errors.hasOwnProperty('login') ? 'has-error' : ''">
                <label for="login" class="form-label">Login</label>
                <input type="text" class="form-control" id="login" v-model="login" placeholder="Login / e-mail">
                <span class="text-danger" v-if="invalidLogin">Usuário/senha inválidos</span>
              </div>
              <div class="mb-3" :class="errors.hasOwnProperty('password') ? 'has-error' : ''">
                <label for="password" class="form-label">Senha</label>
                <input type="password" class="form-control" id="password" v-model="password" placeholder="Senha">
                <span class="text-danger" v-if="invalidLogin">Usuário/senha inválidos</span>
              </div>
              <div class="d-grid">
                <button type="submit" class="btn btn-primary btn-block">
                  Entrar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import axios from 'axios'
    import { mapGetters, mapActions } from 'vuex'

    export default {
        name: 'Login',
        data () {
            return {
                login: '',
                password: '',
                invalidLogin: false,
                errors: {},
                user: {}
            }
        },
        computed: {
            ...mapGetters({
                token: 'auth/token',
            })
        },
        methods: {
            ...mapActions({
                login_user: 'auth/login',
            }),
            logged () {
                axios
                    .post('/api/login', { login: this.login, password: this.password })
                    .then((response) => {
                        this.login_user(response.data)
                        this.$router.push({
                            name: 'home'
                        });
                    })
                    .catch(() => {
                        this.invalidLogin = true
                    })
            }
        }

    }
</script>

